import { getLoginUrl } from './apiHelper';

export function redirectToLoginPage() {
  window.location.href = getLoginUrl();
}
